import R from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import NumberInput from '../../modules/numberInput.jsx';
import { validations } from 'common';

export default class PersonalDataForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.editable = this.props.editable !== false;
    this.state = {};
    this.enableLeaveMessage();
  }
  componentDidUpdate() {
    this.enableLeaveMessage();
  }
  componentWillUnmount() {
    window.onbeforeunload = null;
  }
  enableLeaveMessage() {
    if (this.props.canSave) {
      window.onbeforeunload = (event) => (event || window.event).returnValue = 'Tienes cambios sin guardar.'
    } else {
      window.onbeforeunload = null;
    }
  }
  render() {
    const complete = validations.validateObject(R.pick(['name', 'company', 'age'], validations), this.props.value);
    const incompleteError = () => alert('Faltan campos de llenar.');
    let continueClasses = 'btn btn-lg btn-success';
    if (!complete) {
      continueClasses += ' disabled';
    }

    return (<form style={{ marginTop: '50px' }}>
      <div className='row' style={{ margin: '25px' }}>
        <div className='col-xs-10 col-xs-offset-1'>
          <h3>Completa tus datos personales</h3>
        </div>
      </div>
      {this.renderRow(<label>Nombre</label>, <input type='text' value={this.props.value.name || ""} onChange={(e) => this.props.onChange(R.merge(this.props.value, { name: e.target.value }))}></input>)}
      {this.renderRow(<label>Edad</label>, <NumberInput value={this.props.value.age} onChange={(age) => this.props.onChange(R.merge(this.props.value, { age }))} min="0" max="125" />)}
      {this.renderRow(<label>Sexo</label>, this.renderSexRadioButton())}
      {this.renderRow(<label>Empresa</label>, <input type='text' value={this.props.value.company || ""} onChange={(e) => this.props.onChange(R.merge(this.props.value, { company: e.target.value }))}></input>)}
      <If condition={this.editable}>
        <div style={{ textAlign: 'right' }}>
          <button type='button' style={{ display: 'inline-block', margin: '0px 10px' }} className='btn btn-lg btn-info' disabled={!this.props.canSave} onClick={this.props.onSave}>{ this.props.canSave ? 'Guardar' : 'Guardado' }</button>
          <button type='button' style={{ display: 'inline-block', margin: '0px 10px' }} className={continueClasses} onClick={complete ? this.props.onSubmit : incompleteError}>Continuar</button>
        </div>
      </If>
    </form>);
  }
  renderSexRadioButton() {
    return (<div>
      <div>
        <input type='radio' name='sex' value='Masculino' checked={this.props.value.sex === 'M'} onChange={() => this.props.onChange(R.merge(this.props.value, { sex: 'M' }))} /> Masculino
      </div>
      <div>
        <input type='radio' name='sex' value='Femenino' checked={this.props.value.sex === 'F'} onChange={() => { this.props.onChange(R.merge(this.props.value, { sex: 'F' })) }} /> Femenino
      </div>
    </div>);
  }
  renderRow(left, right) {
    return (
      <div className='row' style={{ margin: '25px' }}>
        <div className='col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1'>
          {left}
        </div>
        <div className='col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1'>
          {right}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/questionnaires/PersonalDataForm.jsx